import AsyncModal from './AsyncModal.vue'

export default AsyncModal
